<template>
<el-dialog
  title="相关性分析"
  :visible.sync="visible"
  :append-to-body="true"
  custom-class="custom-dialog"
  :width="`${chartSize + 40}px`"
>
  <section class="related-chart-group-wrapper">
    <section :style="{width: `${chartSize * relatedDataList.length}px`}">
      <section
        v-for="(relatedData, index) in relatedDataList"
        :key="index"
        :style="{width:`${chartSize}px`,height:`${chartSize}px`,padding:'10px'}"
      >
        <related-chart
          :base-data="currentData"
          :related-data="relatedData"
        />
      </section>
    </section>
  </section>
</el-dialog>
</template>

<script>
import BaseStore from '../../../components/BaseStore'
import {SHOW_RELATED_CHARTS_DIALOG} from './EventKeys'
import RelatedChart from '../../../components/Data/RelatedChart'

export default {
  name: 'AuditRelatedChartsDialog',
  components: {RelatedChart},
  extends: BaseStore,
  props: {
    dataList: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      visible: false,
      currentData: null,
      relatedDataList: []
    }
  },
  computed: {
    chartSize: () => 400,
    dialogWidth () {
      let length = this.relatedDataList.length
      return `${Math.min(length, 3) * this.chartSize + 40}px`
    }
  },
  methods: {
    [SHOW_RELATED_CHARTS_DIALOG] (factorData) {
      this.setRelatedCharts(factorData)
      this.visible = true
    },
    setRelatedCharts (factorData) {
      let factorId = factorData.id
      let relatedFactorMap = this.relatedFactorMap[factorId]
      let {dataList} = this
      this.currentData = Object.freeze(JSON.parse(JSON.stringify(dataList.find(({id}) => id === factorId))))
      this.relatedDataList = Object.freeze(dataList.filter(({id}) => relatedFactorMap[id]))
    }
  },
  created () {
    this.$eventBus.on(SHOW_RELATED_CHARTS_DIALOG, this[SHOW_RELATED_CHARTS_DIALOG])
  },
  beforeDestroy () {
    this.$eventBus.off(SHOW_RELATED_CHARTS_DIALOG, this[SHOW_RELATED_CHARTS_DIALOG])
  }
}
</script>

<style lang="scss" scoped>
.related-chart-group-wrapper {
  width: 100%;
  max-height: 640px;
  overflow: auto;

  > * > * {
    float: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditRelatedChartsDialog.vue